import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  selectLastCapturedCities,
  selectLastCityCaptureStats,
  selectPlayers,
} from '../../../redux/reducers/sharedStateReducer/selectors';
import {selectIsCityCaptureModalVisible} from '../../../redux/selectors/modalVisibility';
import {hideCityCaptureModal} from '../../../redux/actions';
import './CityCaptureModal.css';
import {useEffectOnPositiveChange} from "../../../hooks/react/useEffectOnPositiveChange";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";
import ModalWindow from "../ModalWindow/ModalWindow";
import ModalButton from "../ModalWindow/ModalButton/ModalButton";
import {buildCityCaptureRows} from "./buildCityCaptureRows";
import CityCaptureStatsRow from "./CityCaptureStatsRow";

/**
 * Итоги захвата городов конца раунда — по аналогии с итогами раунда: плашка
 * на каждого игрока, который что-то захватил или потерял (см.
 * buildCityCaptureRows), с числом городов, очками за захват и изменением
 * дохода. Показывается после облета захваченных городов на поле (см.
 * scenes/CityCaptureAnimation)
 */
const CityCaptureModal = () => {
  const dispatch = useDispatch();
  const capturedCities = useSelector(selectLastCapturedCities);
  const captureStats = useSelector(selectLastCityCaptureStats);
  const players = useSelector(selectPlayers);

  // Уступает очередь ВИДИМОЙ боевой модалке, а не поднятому флагу — см.
  // selectIsCityCaptureModalVisible
  const showModalFinal = useSelector(selectIsCityCaptureModalVisible);

  useEffectOnPositiveChange(showModalFinal, () => {
    const soundManager = REGISTRY_SINGLETON.getSoundManager();
    soundManager.playModalCityCapture();
  });

  if (!showModalFinal) {
    return null;
  }

  const handleClose = () => {
    dispatch(hideCityCaptureModal());
  };

  const rows = buildCityCaptureRows(captureStats, capturedCities, players);
  const headerText = capturedCities.length > 1 ? 'Города захвачены!' : 'Город захвачен!';

  return (
    <ModalWindow
      className={'city-capture-modal'}
      handleClose={handleClose}
    >
      <div className="city-capture-modal-header">
        <h2>{headerText}</h2>
      </div>

      <div className="city-capture-modal-content">
        <div className="city-capture-modal-players">
          <div className="city-capture-modal-columns" aria-hidden={'true'}>
            <span className="city-capture-modal-column_cities">Города</span>
            <span className="city-capture-modal-column_points">Очки</span>
            <span className="city-capture-modal-column_income">Доход за раунд</span>
          </div>
          {rows.map((row) => (
            <CityCaptureStatsRow key={row.player.id} row={row}/>
          ))}
        </div>
      </div>

      <div className="city-capture-modal-footer">
        <ModalButton
          onClick={handleClose}
          text={'Продолжить'}
        />
      </div>
    </ModalWindow>
  );
};

export default CityCaptureModal;
